"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendActionEvent = exports.default = exports.configureClient = exports.WATCH_VERIFICATION_VIDEO = exports.VIEW_SEO_LANDING = exports.VIEW_SEARCH = exports.VIEW_PROPERTY = exports.SUGGEST_PRICE = exports.SHARE_LISTING = exports.SELECT_DATES = exports.SELECT_CITY = exports.SAVE_FAVORITE = exports.REQUEST_VERIFICATION = exports.REQUEST_BOOKING = exports.GENERATE_BOOKING_LEAD = exports.GENERATE_BOOKING_INTENTION = exports.FULFILL_PROFILE = exports.ActionEvents = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _ACTIONS_PAYLOAD_SCHE;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SELECT_CITY = 'select_city';
exports.SELECT_CITY = SELECT_CITY;
var VIEW_SEARCH = 'view_search';
exports.VIEW_SEARCH = VIEW_SEARCH;
var VIEW_SEO_LANDING = 'view_seo_landing';
exports.VIEW_SEO_LANDING = VIEW_SEO_LANDING;
var REQUEST_VERIFICATION = 'request_verification';
exports.REQUEST_VERIFICATION = REQUEST_VERIFICATION;
var SUGGEST_PRICE = 'suggest_price';
exports.SUGGEST_PRICE = SUGGEST_PRICE;
var VIEW_PROPERTY = 'view_property';
exports.VIEW_PROPERTY = VIEW_PROPERTY;
var SAVE_FAVORITE = 'save_favorite';
exports.SAVE_FAVORITE = SAVE_FAVORITE;
var FULFILL_PROFILE = 'fulfill_profile';
exports.FULFILL_PROFILE = FULFILL_PROFILE;
var SHARE_LISTING = 'share_listing';
exports.SHARE_LISTING = SHARE_LISTING;
var SELECT_DATES = 'select_dates';
exports.SELECT_DATES = SELECT_DATES;
var WATCH_VERIFICATION_VIDEO = 'watch_verification_video';
exports.WATCH_VERIFICATION_VIDEO = WATCH_VERIFICATION_VIDEO;
var GENERATE_BOOKING_INTENTION = 'generate_booking_intention';
exports.GENERATE_BOOKING_INTENTION = GENERATE_BOOKING_INTENTION;
var GENERATE_BOOKING_LEAD = 'generate_booking_lead';
exports.GENERATE_BOOKING_LEAD = GENERATE_BOOKING_LEAD;
var REQUEST_BOOKING = 'request_booking';
exports.REQUEST_BOOKING = REQUEST_BOOKING;
var FAVORITE_PAGE_TYPES = ['search', 'product_page'];
var FAVORITES_SECTION = ['listing', 'other_rooms', 'similar_properties'];
var SELECT_CITY_PAGE_TYPES = ['homepage', 'seo_landing_page'];
var ACTIONS_PAYLOAD_SCHEMA = (_ACTIONS_PAYLOAD_SCHE = {}, _defineProperty(_ACTIONS_PAYLOAD_SCHE, SELECT_CITY, yup.object().shape({
  cityId: yup.string().required(),
  pageType: yup.string().oneOf(SELECT_CITY_PAGE_TYPES).required()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, VIEW_SEARCH, yup.object().shape({
  cityId: yup.string().required()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, VIEW_SEO_LANDING, yup.object().shape({
  cityId: yup.string().required(),
  slug: yup.string().required()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, REQUEST_VERIFICATION, yup.object().shape({
  listingId: yup.string().required()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, SUGGEST_PRICE, yup.object().shape({
  listingId: yup.string().required(),
  suggestion: yup.number().required(),
  currency: yup.string().required()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, VIEW_PROPERTY, yup.object().shape({
  listingId: yup.string().required()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, SAVE_FAVORITE, yup.object().shape({
  listingId: yup.string().required(),
  pageType: yup.string().oneOf(FAVORITE_PAGE_TYPES).required(),
  section: yup.string().oneOf(FAVORITES_SECTION)
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, FULFILL_PROFILE, yup.object().shape({})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, SHARE_LISTING, yup.object().shape({
  listingId: yup.string().required()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, SELECT_DATES, yup.object().shape({
  listingId: yup.string().required(),
  moveIn: yup.string().required(),
  moveOut: yup.string()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, WATCH_VERIFICATION_VIDEO, yup.object().shape({
  listingId: yup.string().required()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, GENERATE_BOOKING_INTENTION, yup.object().shape({
  listingId: yup.string().required()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, GENERATE_BOOKING_LEAD, yup.object().shape({
  listingId: yup.string().required(),
  bookingLeadId: yup.string().required()
})), _defineProperty(_ACTIONS_PAYLOAD_SCHE, REQUEST_BOOKING, yup.object().shape({
  listingId: yup.string().required(),
  locator: yup.string().required()
})), _ACTIONS_PAYLOAD_SCHE);
var ActionEvents = /*#__PURE__*/_createClass(function ActionEvents(_ref) {
  var _this = this;
  var logger = _ref.logger;
  _classCallCheck(this, ActionEvents);
  this.configureClient = function (sendActionFunction) {
    _this.queuedActions.forEach(function (actionEvent) {
      sendActionFunction(actionEvent);
    });
    _this.queuedActions = [];
    _this.sendActionFunction = sendActionFunction;
  };
  this.isActionIdValid = function (action) {
    return Object.keys(ACTIONS_PAYLOAD_SCHEMA).includes(action);
  };
  this.validatePayload = function (actionId, payload) {
    var actionSchema = ACTIONS_PAYLOAD_SCHEMA[actionId];
    return actionSchema.validateSync(payload);
  };
  this.sendActionEvent = function (actionId, payload) {
    try {
      if (!_this.isActionIdValid(actionId)) {
        _this.logger("invalid actionId: ".concat(actionId));
        return;
      }
      _this.validatePayload(actionId, payload);
      _this.sendActionFunction({
        actionId: actionId,
        payload: payload
      });
    } catch (e) {
      _this.logger("something went wrong sending action: ".concat(actionId, ","), payload, e);
    }
  };
  this.queuedActions = [];
  this.logger = logger;
  this.sendActionFunction = function (actionEvent) {
    return _this.queuedActions.push(actionEvent);
  };
});
exports.ActionEvents = ActionEvents;
var actionEvents = new ActionEvents({
  logger: console.log
});
var configureClient = function configureClient(sendActionFunction) {
  return actionEvents.configureClient(sendActionFunction);
};
exports.configureClient = configureClient;
var sendActionEvent = function sendActionEvent(actionId, payload) {
  return actionEvents.sendActionEvent(actionId, payload);
};
exports.sendActionEvent = sendActionEvent;
var _default = {
  SELECT_CITY: SELECT_CITY,
  VIEW_SEARCH: VIEW_SEARCH,
  VIEW_SEO_LANDING: VIEW_SEO_LANDING,
  REQUEST_VERIFICATION: REQUEST_VERIFICATION,
  SUGGEST_PRICE: SUGGEST_PRICE,
  VIEW_PROPERTY: VIEW_PROPERTY,
  SAVE_FAVORITE: SAVE_FAVORITE,
  FULFILL_PROFILE: FULFILL_PROFILE,
  SHARE_LISTING: SHARE_LISTING,
  SELECT_DATES: SELECT_DATES,
  WATCH_VERIFICATION_VIDEO: WATCH_VERIFICATION_VIDEO,
  GENERATE_BOOKING_INTENTION: GENERATE_BOOKING_INTENTION,
  GENERATE_BOOKING_LEAD: GENERATE_BOOKING_LEAD,
  REQUEST_BOOKING: REQUEST_BOOKING,
  configureClient: configureClient,
  sendActionEvent: sendActionEvent,
  ActionEvents: ActionEvents
};
exports.default = _default;
//# sourceMappingURL=ActionEvents.js.map